import { autoinject, bindable } from 'aurelia-framework';
import { NodeModel } from '../../models/node-model';

@autoinject
export class TreeSearch {
    @bindable placeholder: string;
    @bindable searchTerm: string;
}
